export const BUY_CHARGER_ID = 'buy-charger';
export const RENT_CHARGER_ID = 'rent-charger';
